import { render, staticRenderFns } from "./RuleCollectionGrid.vue?vue&type=template&id=4e9c80a3&"
import script from "./RuleCollectionGrid.vue?vue&type=script&lang=js&"
export * from "./RuleCollectionGrid.vue?vue&type=script&lang=js&"
import style0 from "./RuleCollectionGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports